/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/collection-filters.js":
/*!**************************************!*\
  !*** ./src/js/collection-filters.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n // import smoother from './smoother';\n// const filterTl = gsap.timeline({ paused: true });\n// const duration = .8;\n// filterTl\n//   .fromTo('.filter-menu', {\n//     height: 0,\n//   }, {\n//     height: 'auto',\n//     ease: 'none',\n//   });\n\n$('.filter-menu__trigger, .filter-menu__close').on('click', function (e) {\n  e.preventDefault();\n\n  if ($('body').hasClass('filter-menu--show')) {\n    $('body').removeClass('filter-menu--show'); // filterTl.tweenTo(0, { ease: 'circ.out', duration });\n  } else {\n    $('body').addClass('filter-menu--show'); // filterTl.tweenTo(1, { ease: 'circ.in', duration });\n    // smoother.scrollTop(0);\n  }\n}); // $('.filter-menu__close').on('click', function(e) {\n//   e.preventDefault();\n//   $('body').removeClass('filter-menu--show');\n//   filterTl.reverse();\n// });\n\n//# sourceURL=webpack://Mahsa/./src/js/collection-filters.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/js/collection-filters.js"](0, __webpack_exports__, __webpack_require__);
/******/ 	
/******/ })()
;